import Form from '../../../../../../components/form';
import request from '../../../../../../utils/request';
import ImgList from './components/img_list.vue';
import awardList from './components/awardList.vue';

formCreate.component('ImgList', ImgList);
formCreate.component('awardList', awardList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'main_form',
      formParentCode: 'CRM20250820000000002',
      fields: ['banquetCode', 'banquetName', 'banquetTime', 'banquetProductCode', 'banquetProductName', 'executeTableNum', 'takeUserName', 'takeTime', 'openRate', 'allOpenRatio', 'errOpenRatio', 'openRatio', 'actExecutePositionName', 'actExecuteUserName'],
    };
  },
  methods: {

    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'auditTableNum') { //  申请桌数
        v.props = {
          ...v.props,
          min: 0,
          precision: 0,
          controls: false,
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      this.disabled(true, this.fields);
      console.log('formData____122222', this.formConfig);
      request
        .post('/sfa/banquetReport/executeDetail', {
          executeCode: this.formConfig.row.executeCode,
        })
        .then((res) => {
          if (res.success) {
            const { result } = res;
            console.log(result);
            this.setValue(result);
          }
        });
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const url = '/sfa/banquetReport/executeApprove';
        const params = formData;
        delete params.title1;
        params.id = this.formConfig.row.id;
        params.executeCode = this.formConfig.row.executeCode;
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
